import { ReactNode } from 'react';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from './AppSidebar';
import { useMerchant } from '@/contexts/MerchantContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Building2 } from 'lucide-react';
import { NotificationBell } from './NotificationBell';

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { selectedMerchantId, setSelectedMerchantId, merchants, loading } = useMerchant();

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <header className="h-14 sm:h-16 border-b border-border bg-card flex items-center px-3 sm:px-6 gap-2 sm:gap-4 sticky top-0 z-30">
            <SidebarTrigger className="-ml-1 sm:-ml-2" />
            <div className="flex items-center gap-2 ml-auto">
              <NotificationBell />
              <Building2 className="w-4 h-4 text-muted-foreground hidden sm:block" />
              <Select
                value={selectedMerchantId || 'all'}
                onValueChange={(value) => setSelectedMerchantId(value === 'all' ? null : value)}
                disabled={loading}
              >
                <SelectTrigger className="w-[140px] sm:w-[200px] bg-background text-xs sm:text-sm">
                  <SelectValue>
                    {selectedMerchantId 
                      ? merchants.find(m => m.id === selectedMerchantId)?.merchant_name || 'Select merchant'
                      : 'All Merchants'}
                  </SelectValue>
                </SelectTrigger>
                <SelectContent className="bg-background z-50">
                  <SelectItem value="all">All Merchants</SelectItem>
                  {merchants.map((merchant) => (
                    <SelectItem key={merchant.id} value={merchant.id}>
                      {merchant.merchant_name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </header>
          <main className="flex-1 overflow-auto">
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default DashboardLayout;
